import * as Yup from 'yup'

export const initialValues = defaults => ({
    firstName: defaults?.firstName || '',
    lastName: defaults?.lastName || '',
    email: defaults?.email || '',
    phone: defaults?.phone || '',
    company: defaults?.company || '',
    address: defaults?.address || '',
})

export const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string()
        .email('Email is invalid')
        .required('Email is required'),
    phone: Yup.string()
        .matches(
            /\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}/g,
            'Phone number is not valid',
        )
        .required('Phone is required'),
    company: Yup.string().required('Company is required'),
    address: Yup.string().required('Address is required'),
})
